import { render, staticRenderFns } from "./SearchTexts.vue?vue&type=template&id=5fa37109&"
import script from "./SearchTexts.vue?vue&type=script&lang=js&"
export * from "./SearchTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports